<template>
  <div class="events-frame">
    <div class="events-months">
      <button :class="{active: selectedMonth === 'all'}" @click="selectedMonth = 'all'">
        <span>{{ $t("events.allEvents") }}</span>
      </button>
      <button
        v-for="month in months"
        :key="month.key"
        :class="{active: selectedMonth === month.key}"
        @click="selectedMonth = month.key"
      >
        <span>{{ month.labelMonth }}</span>
        <span>{{ month.labelYear }}</span>
      </button>
    </div>

    <div class="events-list">
      <EventsCard v-for="event in filteredEvents" :key="event.id" :event="event" @click.native="selectEvent(event)" />
    </div>
    <div v-if="loadingEvents" class="events-loading">
      {{ $t("events.loading") }}
    </div>

    <div v-else-if="filteredEvents.length === 0" class="no-events">
      {{ $t("events.noEvents") }}
    </div>
  </div>
</template>

<script>
import EventsService from "@/services/map/events";
import EventsCard from "./EventsCard.vue";


export default {
  name: "EventsFrame",

  components: {
    EventsCard,
  },

  data() {
    return {
      events: [],
      months: [],
      selectedMonth: null,
      loadingEvents: true,
    };
  },

  computed: {
    filteredEvents() {
      if (!this.selectedMonth || this.selectedMonth === "all") {
        return this.events;
      }

      return EventsService.filterByMonth(this.events, this.selectedMonth);
    },
  },
watch: {
  "$i18n.locale": {
    immediate: false,

    async handler(newLocale, oldLocale) {
      if (!newLocale || newLocale === oldLocale) return;

      console.log("[EventsFrame] schimbare limbă:", {
        oldLocale,
        newLocale,
      });

      await this.loadEvents(newLocale);

      // regenerează lunile în limba selectată
      this.months = this.generateNextMonths(24);
    },
  },
},

  async mounted() {
    this.loadingEvents = true;
    this.months = this.generateNextMonths(24);
    this.selectedMonth = "all";
    // this.selectedMonth = this.months[0]?.key || null;
    this.events = await EventsService.getEvents(this.$i18n?.locale);
    // console.log("[EventsFrame] ALL EVENTS:", this.events);
    this.loadingEvents = false;
      await this.loadEvents(this.$i18n.locale);
  },

  methods: {
      async loadEvents(locale = this.$i18n.locale) {
    this.loadingEvents = true;

    try {
      const events = await EventsService.getEvents(locale);

      console.log(
        "[EventsFrame] evenimente pentru limba:",
        locale,
        events.map((e) => ({
          id: e.id,
          title: e.title,
          name: e.name,
          poi_name: e.poi_name,
          poiName: e.poi?.name,
          contact: e.poi?.contact,
        }))
      );

      this.events = events;
    } catch (error) {
      console.error(
        "[EventsFrame] eroare încărcare evenimente:",
        error
      );
    } finally {
      this.loadingEvents = false;
    }
  },
    // selectEvent(event) {
    //   console.log("EVENT SELECTAT:", JSON.parse(JSON.stringify(event)));

    //   const eventId =
    //     event.event_id ??
    //     event.id ??
    //     (event.event_index != null ? `event-${event.parent_id}-${event.poi_id}-${event.event_index}` : null);

    //   const poiId = event.poi_id ?? event.poi?.id;

    //   const parentId = event.parent_id ?? event.poi?.parent?.id;

    //   if (!eventId || !poiId || !parentId) {
    //     console.error("Date incomplete pentru eveniment:", {
    //       eventId,
    //       poiId,
    //       parentId,
    //       event: JSON.parse(JSON.stringify(event)),
    //     });

    //     return;
    //   }

    //   this.$emit("select-poi", {
    //     ...(event.poi || {}),
    //     id: poiId,

    //     parent: {
    //       id: parentId,
    //       name: "Calendar Evenimente",
    //     },

    //     fromEvent: true,
    //     eventId,
    //     poiId,
    //     parentId,
    //   });
    // },
    async selectEvent(event) {
  console.log(
    "[EventsFrame] EVENT SELECTAT:",
    JSON.parse(JSON.stringify(event))
  );

  const eventId =
    event.event_id ??
    event.id ??
    (
      event.event_index != null
        ? `event-${event.parent_id}-${event.poi_id}-${event.event_index}`
        : null
    );

  const poiId =
    event.poi_id ??
    event.poi?.id;

  const parentId =
    event.parent_id ??
    event.poi?.parent_id ??
    event.poi?.parent?.id;

  if (!eventId || !poiId || !parentId) {
    console.error(
      "[EventsFrame] Date incomplete pentru eveniment:",
      {
        eventId,
        poiId,
        parentId,
        event: JSON.parse(
          JSON.stringify(event)
        ),
      }
    );

    return;
  }

  /*
   * Trimitem POI-ul către componenta care controlează harta.
   * Păstrăm și proprietățile POI existente, inclusiv geometria,
   * iconul și stilul, atunci când vin în event.poi.
   */
  const selectedPoi = {
    ...(event.poi || {}),

    id: poiId,
    poi_id: poiId,

    parent_id: parentId,

    parent: {
      ...(event.poi?.parent || {}),
      id: parentId,
      name:
        event.poi?.parent?.name ||
        "Calendar Evenimente",
    },

    fromEvent: true,
    eventId,
    event_id: eventId,
  };

  console.log(
    "[EventsFrame] POI trimis către hartă:",
    selectedPoi
  );

  /*
   * Mai întâi cerem afișarea pe hartă.
   */
  this.$emit("select-poi", selectedPoi);

  /*
   * Apoi schimbăm ruta.
   */
  await this.$nextTick();

  this.$router
    .push({
      name: "eventDetails",

      params: {
        id: String(eventId),
      },

      query: {
        poi_id: String(poiId),
        parent: String(parentId),
      },
    })
    .catch((error) => {
      if (
        error?.name !==
        "NavigationDuplicated"
      ) {
        console.error(
          "Eroare la deschiderea evenimentului:",
          error
        );
      }
    });
},

    generateNextMonths(count = 24) {
      const result = [];
      const today = new Date();

      for (let i = 0; i < count; i++) {
        const date = new Date(today.getFullYear(), today.getMonth() + i, 1);

        result.push({
          key: `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`,
          labelMonth: date.toLocaleDateString("en", {month: "short"}),
          labelYear: date.getFullYear(),
        });
      }

      return result;
    },
  },
};
</script>

<style scoped>
.events-frame {
  background: #eef1f3;
  width: 100%;
  overflow: hidden;
}

.events-months {
  display: flex;
  gap: 8px;
  background: #eef1f3;
  overflow-x: auto;
  padding-bottom: 12px;
  padding-top: 8px;
}

.events-months button {
  width: 42px;
  height: 42px;
  min-width: 42px;
  border: 0;
  border-radius: 10px;
  background: #f4f4f4;
  color: #555;
  cursor: pointer;
  flex-shrink: 0;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.18);
  font-weight: 700;
}

.events-months button.active {
  background: #d0d0d0;
  color: #222;
}

.events-months button span {
  display: block;
  line-height: 1.1;
  font-size: 11px;
}

/* .events-list {
  max-height: calc(100vh - 210px);
  overflow-y: auto;
  padding-bottom: 8px;
} */
.events-loading,
.no-events {
  margin-top: 12px;
  font-family: Quicksand;
  color: #777;
  font-size: 14px;
}
</style>